<template>
  <div>

    <v-toolbar dense elevation="0">
      <v-spacer />

      <v-btn
        icon
        @click="cancelar"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <TempleteConteudoDialog class="text-center d-flex justify-center align-center">
      <ProgressoCarregamentoFase v-if="carregando_dados" />

      <div v-show="!carregando_dados">
        <div id="bola-fundo-icone" class="mx-auto">
          <v-icon id="icone-position" class="mt-n4 ml-n2">$BaixarArquivo</v-icon>
        </div>

        <p id="decricao" class="mb-6" v-text="'Relatórios de compras baixadas com sucesso!'" />

        <SysDialog
          v-model="dialog"
          titulo="Aviso"
          ocultarAcoes
          largura="70%"
        >
          <ul class="pb-5">
            <li v-for="(msg, idx) in message_errors" :key="idx" >
              {{ msg }}
            </li>
          </ul>
        </SysDialog>
      </div>
    </TempleteConteudoDialog>
  </div>
</template>

<script>
import TempleteConteudoDialog from '../ajudantes/TempleteConteudoDialog.vue';
import ProgressoCarregamentoFase from '../ProgressoCarregamentoFase.vue';
import SysDialog from '../../../../padraoDeLayout/SysDialog.vue';

export default {
  name: "ConclusaoDaAnalise",
  props: {
    message_errors: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    carregando_dados: false,
    dialog: false
  }),
  mounted() {
    this.abrirDialogMessage();
  },
  methods: {
    cancelar() {
      this.$emit("fechar-dialog", {});
    },
    abrirDialogMessage() {
      if (this.message_errors.length > 0) {
        this.dialog = this.message_errors.length > 0;
        this.carregando_dados = !this.message_errors.length > 0;
      }
    }
  },
  components: {
    TempleteConteudoDialog,
    ProgressoCarregamentoFase,
    SysDialog
  }
}
</script>

<style scoped>
  #decricao {
    font-size: 24px;
    color: #142454;
    line-height: 24px;
    margin: 16px 0;
  }
  #icone-position {
    z-index: 99;
  }
  #bola-fundo-icone {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 65px;
    height: 65px;
    border-radius: 50%;
    background-color: #a51b3250;
  }
</style>
